/* share buttons in foglia */
function shareButtons() {
  var me = this;
  me.buttons;
  me.w = 600;
  me.h = 300;
  me.recipeTitle;
  me.recipeUrl;

  me.init = () => {
    me.buttons = document.querySelectorAll(
      ".dm20-lory-share-panel [data-social]"
    );
    me.recipeTitle = document.querySelector(".post-title").innerHTML;
    me.recipeUrl = location.protocol + "//" + location.host + location.pathname;

    me.handleClick();
  };

  me.handleClick = () => {
    me.buttons.forEach((btn) => {
      btn.addEventListener("click", (ev) => {
        ev.preventDefault();
        me.appendUrl(btn);
      });
    });
  };

  me.appendUrl = (btn) => {
    let button = btn;
    let socialName = button.dataset.social;
    let imageUrl = button.dataset.image || null;
    let url = "";

    switch (socialName) {
      case "fb":
        url =
          "https://www.facebook.com/sharer/sharer.php?u=" +
          me.recipeUrl +
          "&amp;t=" +
          me.recipeTitle;
        break;
      case "tw":
        url =
          "https://twitter.com/share?text=" +
          me.recipeTitle +
          "&amp;url=" +
          me.recipeUrl;
        break;
      case "wa":
        url = "whatsapp://send?text=" + me.recipeTitle + " - " + me.recipeUrl;
        break;
      case "pt":
        url =
          "https://pinterest.com/pin/create/bookmarklet/?url=" +
          me.recipeUrl +
          "&amp;media=" +
          imageUrl +
          "&amp;description=" +
          me.recipeTitle;
        break;
      case "whatsapp":
        url =
          "https://api.whatsapp.com/send?text=" +
          me.recipeTitle +
          "%0a" +
          me.recipeUrl;
        break;
      case "fm":
        if (device == "smartphone") {
          url =
            "fb-messenger://share?link=" +
            me.recipeUrl +
            "&text=" +
            me.recipeTitle;
        } else {
          url =
            "https://www.facebook.com/dialog/send?app_id=218317100612&display=popup&link=" +
            me.recipeUrl +
            "&redirect_uri=" +
            me.recipeUrl;
        }
        break;
    }

    window.open(
      url,
      socialName + "-window",
      "menubar=0,resizable=1,width=" + me.w + ",height=" + me.h
    );
  };
}

const shares = new shareButtons();
shares.init();
/* end share buttons in foglia */

function ratingContent(element) {
  var me = this;
  (me.items = []),
    (me.userHasVoted = false),
    (me.localStorageSupport = false),
    me.contentId,
    me.contentRate,
    me.voteBtn,
    me.ratingPanel,
    me.ratingCurrentPlaceholder,
    me.wrapCat;

  me.init = () => {
    me.ratingPanel = element;
    me.voteBtn = me.ratingPanel.querySelectorAll(".rating_vote_btn");
    me.ratingCurrentPlaceholder =
      me.ratingPanel.querySelectorAll(".rating_current");
    me.wrapCat = element.parentNode;

    var tmpItems = me.ratingPanel.querySelectorAll(".rating_item");

    if (!me.ratingPanel) {
      return false;
    }

    me.contentId = me.ratingPanel.dataset.contentId;
    me.contentRate = me.ratingPanel.dataset.contentRate;

    if (typeof localStorage !== "undefined") {
      me.localStorageSupport = true;
    }

    if (
      me.localStorageSupport &&
      localStorage.getItem("content-" + me.contentId)
    ) {
      me.userHasVoted = true;

      if (!me.contentRate) {
        me.contentRate = localStorage.getItem("content-" + me.contentId);
      }
    } else {
      me.enableVoteMode();
    }

    me.setRatingCurrentPlaceholder(me.contentRate);

    for (var i = 0; i < tmpItems.length; i++) {
      var item = tmpItems[i];
      me.items.push(item);
      me.attachEvents(item);
    }

    me.wrapCat.classList.add("panel_enabled");
  };

  me.enableVoteMode = () => {
    me.wrapCat.classList.add("vote_enabled");

    if (!me.contentRate) {
      me.wrapCat.classList.add("no_vote");
    }

    me.voteBtn[0].addEventListener("click", function (ev) {
      if (me.ratingPanel.classList.contains("vote_opened")) {
        me.ratingPanel.classList.remove("vote_opened");
      } else {
        me.ratingPanel.classList.add("vote_opened");
      }
    });
  };

  me.iterate = (collection, callback) => {
    for (var i = 0; i < collection.length; i++) {
      var item = collection[i];
      callback(item, i);
    }
  };

  me.attachEvents = (item) => {
    item.addEventListener("mouseover", me.itemMouseOver);
    item.addEventListener("mouseout", me.itemMouseOut);
    item.addEventListener("click", me.itemClick);
  };

  me.itemMouseOver = (ev) => {
    var currentItem = ev.target;
    me.iterate(me.items, function (item, index) {
      if (index <= parseInt(currentItem.getAttribute("data-index"))) {
        item.classList.add("rating_active");
      } else {
        item.classList.remove("rating_active");
      }
    });
  };

  me.itemMouseOut = (ev) => {
    if (me.items.indexOf(ev.relatedTarget) === -1) {
      me.setRating(null, false);
    }
  };

  me.itemClick = (ev) => {
    ev.preventDefault();

    var currentItem = ev.target;
    me.setRating(
      parseInt(currentItem.getAttribute("data-index")) + 1,
      me.registerVote
    );
  };

  me.setRating = (value, callback) => {
    if (value && value < 0) {
      return;
    }

    if (value) {
      me.iterate(me.items, function (item, index) {
        if (index < value) {
          item.classList.add("rating_setted");
        } else {
          item.classList.remove("rating_setted");
        }
      });

      if (callback) {
        callback(value);
      }
    } else {
      me.iterate(me.items, function (item, index) {
        if (index < 0) {
          item.classList.add("rating_active");
        } else {
          item.classList.remove("rating_active");
        }
      });
    }
  };

  me.getRating = () => {
    return me.contentRate;
  };

  me.registerVote = (value) => {
    localStorage.setItem("content-" + me.contentId, value);
    me.userHasVoted = true;

    document.querySelectorAll(".dm20-wrap-rating").forEach(function (item) {
      item.classList.remove("no_vote");
      item.classList.remove("vote_enabled");
    });

    document.querySelectorAll(".rating_panel").forEach(function (item) {
      item.classList.remove("vote_opened");
      item.classList.add("voted");
    });

    var data = new FormData();
    data.append("action", "load_rating");
    data.append("id", me.contentId);
    data.append("value", value);

    fetch(document.body.dataset.url, {
      method: "POST",
      insecure: true,
      body: data,
    })
      .then((res) => {
        return res.json();
      })
      .then((response) => {
        if (response.status == true) {
          me.setRatingCurrentPlaceholder(response.rating);
          // ga(
          //     'send',
          //     {
          //         'hitType': 'event',
          //         'eventCategory': 'Rating',
          //         'eventAction': 'Voto',
          //         'eventLabel': window.location.href,
          //         'eventValue': value,
          //         'nonInteraction': 1
          //     }
          // );

          gtag("event", "Voto", {
            event_category: "Rating",
            event_label: window.location.href,
            value: value,
            non_interaction: true,
          });
        } else {
          me.setRatingCurrentPlaceholder(value);
          // ga(
          //     'send',
          //     {
          //         'hitType': 'event',
          //         'eventCategory': 'Rating',
          //         'eventAction': response.msg,
          //         'eventLabel': window.location.href,
          //         'eventValue': value,
          //         'nonInteraction': 1
          //     }
          // );

          gtag("event", response.msg, {
            event_category: "Rating",
            event_label: window.location.href,
            value: value,
            non_interaction: true,
          });
        }
      });
  };

  me.setRatingCurrentPlaceholder = (rating) => {
    document.querySelectorAll(".rating_current").forEach(function (item) {
      item.innerHTML = rating;
    });
  };
}

const ratings = {};
document.querySelectorAll(".rating_panel").forEach((el, index) => {
  ratings[index] = new ratingContent(el);
  ratings[index].init();
});

// LISTA INGREDIENTI

function listaIngredienti() {
  var me = this;
  me.init = function () {
    me.body = document.body;
    me.bottonemodale = document.querySelector(".dm20-vanda-lista .lista-spesa");
    me.listato = document.querySelector(".dm20-vanda .ingredienti-lista");
    me.ingredienti = document.querySelectorAll(
      ".ingredienti-lista .ingrediente-singolo .dm20-vanda-button-hidden"
    );
    me.modale = document.querySelector(".dm20-vanda-modale");
    me.modalelistato = document.querySelector(
      ".dm20-vanda-modale .dm20-vanda-modale-lista"
    );
    me.modalechiudi = document.querySelector(".dm20-vanda-closebtn");
    me.modalecontainer = document.querySelector(".dm20-vanda-modale-cont");
    me.ricetta = document.querySelector(".dm20-lory-title");

    // listener sul check degli ingredienti
    me.ingredienti.forEach((ingrediente) => {
      ingrediente.addEventListener("change", function () {
        me.ingredientiselezionati = document.querySelectorAll(
          ".ingredienti-lista .ingrediente-singolo .dm20-vanda-button-hidden:checked"
        );
        // al check visualizzo il bottone e le opzioni per la modale
        if (me.ingredientiselezionati.length) {
          // prima di tutto mostro il bottone
          me.bottonemodale.classList.add("show");
          me.bottonemodale.addEventListener("click", function () {
            me.modale.classList.add("open");
            me.body.classList.add("modale-lista");
            me.getLista();
            // chudo modale dal bottone e da click fuori dal contenitore
            me.modalechiudi.addEventListener("click", function () {
              me.modale.classList.remove("open");
              me.body.classList.remove("modale-lista");
            });
            me.modale.addEventListener("click", function (e) {
              if (e.target !== this) return;

              me.modale.classList.remove("open");
              me.body.classList.remove("modale-lista");
            });
          });
        } else {
          me.bottonemodale.classList.remove("show");
        }
      });
    });
  };
  me.getLista = function () {
    // svuoto la lista ogni volta
    me.modalelistato.innerHTML = "";
    me.modalemail = document.querySelector(".dm20-vanda-modale-button-send");
    // compilo il corpo per la mail
    let listamail =
      "La ricetta che vuoi cucinare è " +
      me.ricetta.innerHTML +
      " - " +
      window.location.href +
      " %0AEcco la tua lista della spesa:%0A";
    // prendo tutti gli ingredienti checkati e li copia nella lista della modale
    me.ingredientiselezionati.forEach((ingrediente) => {
      let ingredientelista = ingrediente.value.trim();
      let li = document.createElement("li");
      li.innerHTML += ingredientelista;
      li.setAttribute("class", "dm20-vanda-modale-lista-item");
      me.modalelistato.appendChild(li);
      // metto gli ingredienti nella mail
      listamail += ingredientelista + "%0A";
    });
    let mailsubject = me.modalemail.getAttribute("data-subject");
    me.modalemail.setAttribute(
      "href",
      "mailto:?" + mailsubject + "&body=" + listamail
    );
  };
}

// per essere sicuro che ci sia almeno un ingrediente in pagina
var checkingredienti = document.querySelector(
  ".ingredienti-lista .ingrediente-singolo"
);

if (checkingredienti) {
  var listaIngredientifoglia;
  listaIngredientifoglia = new listaIngredienti();
  listaIngredientifoglia.init();
}

// tracking links abbonamenti in pagina
let TrackOfferte = () => {
  let abbbtns = document.querySelectorAll(".btn-offerte-amazon");
  Array.from(abbbtns).forEach((el, i) => {
    el.addEventListener("click", (e) => {
      console.debug("clicked on Bottone " + i);
      // ga('send', {
      //     hitType: 'event',
      //     eventCategory: 'Bottone Infocommerce',
      //     eventAction: 'Click',
      //     nonInteraction: true
      // });

      gtag("event", "Click", {
        event_category: "Bottone Infocommerce",
        non_interaction: true,
      });
    });
  });
  console.debug("[TrackOfferte] " + abbbtns.length + " buttons found.");
};
TrackOfferte();

// tracking links correlati a fine foglia
let TrackRelated = () => {
  let rltd = document.querySelectorAll(
    ".dm20-fullwidth .dm20-daniela .dm20-daniela-img-link"
  );
  let rltd2 = document.querySelectorAll(
    ".dm20-fullwidth .dm20-daniela .dm20-daniela-title a"
  );
  Array.from(rltd).forEach((el, i) => {
    el.addEventListener("click", (e) => {
      int = i + 1;
      console.debug("[TrackRelated] clicked on Correlato " + int);
      // ga('send', {
      //     hitType: 'event',
      //     eventCategory: 'Correlati',
      //     eventAction: 'Click',
      //     eventLabel: 'pos ' + int + ', ' + el.getAttribute("href"),
      //     nonInteraction: true
      // });

      gtag("event", "Click", {
        event_category: "Correlati",
        event_label: "pos " + int + ", " + el.getAttribute("href"),
        non_interaction: true,
      });
    });
  });
  Array.from(rltd2).forEach((el, i) => {
    el.addEventListener("click", (e) => {
      int = i + 1;
      console.debug("[TrackRelated] clicked on Correlato " + int);
      // ga('send', {
      //     hitType: 'event',
      //     eventCategory: 'Correlati',
      //     eventAction: 'Click',
      //     eventLabel: 'pos ' + int + ', ' + el.getAttribute("href"),
      //     nonInteraction: true
      // });

      gtag("event", "Click", {
        event_category: "Correlati",
        event_label: "pos " + int + ", " + el.getAttribute("href"),
        non_interaction: true,
      });
    });
  });
  console.debug("[TrackRelated] " + rltd.length + " related found.");
};
TrackRelated();

function openSocialSharer() {
  const trigger = document.querySelector(".social-share-modal-trigger");
  const modal = document.querySelector(".social-share-modal-modal");

  if (!trigger || !modal) {
    return;
  }

  trigger.addEventListener("click", () => {
    modal.style.display = "block";
  });

  const closeModalTrigger = modal.querySelector(".modal-close");
  console.log(closeModalTrigger)
  closeModalTrigger.addEventListener("click", () => {
    console.log(modal);

    modal.style.display = "none";
  });
}

openSocialSharer();



(function () {
	const sliders = document.querySelectorAll(".slider-container");
	sliders.forEach((slider) => {
		const sliderEl = slider.querySelector(".swiper");

		if (sliderEl) {
			new Swiper(sliderEl, {
				slidesPerView: sliderEl.getAttribute("data-per-view-mobile") ? sliderEl.getAttribute("data-per-view-mobile") : 3,
				spaceBetween: 20,
				navigation: {
					nextEl: slider.querySelector(".slider-button-next"),
					prevEl: slider.querySelector(".slider-button-prev"),
				},
				breakpoints: {
					640: {
						slidesPerView: sliderEl.getAttribute("data-per-view") ? sliderEl.getAttribute("data-per-view") : 3
					}
				}
			});
		}
	});
})();
